import TopNav from '../components/top-nav';
import { usePageTitle } from '../utils/page-title';

// Served when user requests a dynamic route like /podcasts/*
// Not needed during client-side routing, but pre-rendered so Vercel and service worker can serve it
export default function FallbackPageShell() {
  usePageTitle(undefined); // Default value
  return (
    <>
      <TopNav />
      {/* I intentionally use a <p> tag to force Preact to swap it out w/ actual /podcasts/* page content during hydration */}
      <p style="height: 50vh; display: flex; align-items: center; justify-content: center; color: #bbb">
        Loading...
      </p>
    </>
  );
}
